import Accounting from 'accounting-js'

export default {
  data: function () {
    return {
      feeSchedule: {
        '195percent': {
          10000000000: {
            type: 'percentage',
            amount: 1.95
          }
        },
        '200percent': {
          10000000000: {
            type: 'percentage',
            amount: 2.00
          }
        },
        '250percent': {
          10000000000: {
            type: 'percentage',
            amount: 2.50
          }
        },
        '275percent': {
          10000000000: {
            type: 'percentage',
            amount: 2.75
          }
        },
        '295percent': {
          10000000000: {
            type: 'percentage',
            amount: 2.95
          }
        },
        '300percent': {
          10000000000: {
            type: 'percentage',
            amount: 3.00
          }
        },
        '320percent': {
          10000000000: {
            type: 'percentage',
            amount: 3.20
          }
        },
        '350percent': {
          10000000000: {
            type: 'percentage',
            amount: 3.50
          }
        },
        '375percent': {
          10000000000: {
            type: 'percentage',
            amount: 3.75
          }
        },
        '380percent': {
          10000000000: {
            type: 'percentage',
            amount: 3.80
          }
        },
        '400percent': {
          10000000000: {
            type: 'percentage',
            amount: 4.00
          }
        },
        blueyonder395: {
          10000000000: {
            type: 'percentage',
            amount: 3.95
          }
        },
        blueyonder350: {
          10000000000: {
            type: 'percentage',
            amount: 3.5
          }
        },
        okdmv: {
          10000000000: {
            type: 'percentage',
            amount: 2.25,
            feeAppend: 200,
            feePrepend: 200
          }
        }
      }
    }
  },

  methods: {
    calculateRate (terminal) {
      if (!terminal.hasOwnProperty('is_cashdiscount') ||
        !terminal.is_cashdiscount ||
        !terminal.hasOwnProperty('cashdiscount_schedule')
      ) {
        return 0
      }

      let feeScheduleKey = terminal.cashdiscount_schedule
      if (!this.feeSchedule[feeScheduleKey]) {
        return 0
      }

      let feeSchedule = this.feeSchedule[feeScheduleKey]

      if (feeSchedule.hasOwnProperty('10000000000') && feeSchedule['10000000000'].type === 'percentage') {
        return feeSchedule['10000000000'].amount
      }

      return 0
    },

    calculateFee (terminal, amount) {
      // validate schedule
      if (!terminal.hasOwnProperty('is_cashdiscount') ||
        !terminal.is_cashdiscount ||
        !terminal.hasOwnProperty('cashdiscount_schedule')
      ) {
        return 0.00
      }

      // validate amount
      if (isNaN(amount) || amount === null || Number(amount) === 0) {
        return 0.00
      }

      amount = amount * 100

      let feeScheduleKey = terminal.cashdiscount_schedule
      if (!this.feeSchedule[feeScheduleKey]) {
        return 0.00
      }
      let feeSchedule = Object.keys(this.feeSchedule[feeScheduleKey])
      let key = feeSchedule.find(value => Number(value) > Number(amount))
      let formula = this.feeSchedule[feeScheduleKey][key]

      if (formula.type === 'rate') {
        return Accounting.toFixed((formula.amount + amount) / 100)
      } else {
        if (formula.hasOwnProperty('feePrepend') && formula.feePrepend) {
          amount += formula.feePrepend
        }

        amount = amount * (formula.amount / 100)

        if (formula.hasOwnProperty('feeAppend') && formula.feeAppend) {
          amount += formula.feeAppend
        }

        return Accounting.toFixed(amount / 100)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/cashDiscount.js